module.exports = __webpack_public_path__ + "static/media/error.1af1e84a.wav";